// extracted by mini-css-extract-plugin
export default {"checklist":"JoinModal_checklist__6xOkY","checklistDot":"JoinModal_checklistDot__N-Usm"};